pathIsAbsolute